import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import Select from 'react-select';

export default function NewAeps() {
  const bankOptions = [
    { value: '990320', label: 'Airtel Payment Bank' },
    { value: '607105', label: 'Allahabad Bank' },
    { value: '607024', label: 'Allahabad UP Gramin Bank' },
  ];

  return (
    <>
      <Header />
      <div className="adminuiux-wrap">
        <Sidebar />
        <main
  className="adminuiux-content has-sidebar"
>

  <div className="container " id="main-content">
    <div className="row align-items-center">
    </div>
    <input type="hidden" id="order_id" />
    <input type="hidden" id="user_id" defaultValue={12279} />
    <div style={{ display: "none" }} className="bioscan" />
    {/* dashboard inner */}
    <div className="midde_cont">
      <div className="container-fluid">
        <div className="row column_title">
          <div className="col-md-12">
            <div className="page_title d-sm-flex">
              {/*<h2>AePS</h2>*/}
              <a
                className="btn btn-primary"
                href="https://kiaraapay.com/new/aeps/two-factor"
              >
                Two Factor Authentication
              </a>{" "}
              <a
                className="btn btn-primary"
                style={{ marginLeft: 10 }}
                href="https://kiaraapay.com/new/aeps/kyc"
              >
                Kyc
              </a>
              
            </div>
          </div>
        </div>
        <div className="row">
          <div className="card adminuiux-card mt-4">
            <div className="card-content">
              <div className="card-header">
                {/*<h6 class="text-white mb-1">ICICI AEPS</h6>*/}
              </div>
              <div className="card-body">
                <div className="row">
                  <input
                    type="hidden"
                    name="_token"
                    defaultValue="EeQVcAQS1kOwAOoxuyPZzMH5LawYI8YUrTufMPg5"
                  />{" "}
                  <input type="hidden" id="BiometricData" />
                  <input type="hidden" id="pidtype" />
                  <input type="hidden" id="ci" />
                  <div className="col-md-12 col-12">
                    <div className="row">
                      <div className="col-md-7">
                        <ul className="list-unstyled mb-0 ml-4">
                          <li className="d-inline-block mr-2">
                            <div className="custom-control custom-radio custom-control-inline">
                              <input
                                type="radio"
                                name="service"
                                defaultChecked="checked"
                                defaultValue={133}
                                id="service_1"
                                onclick="service('1')"
                                className="custom-control-input"
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="service_1"
                              >
                                Cash Withdrawal
                              </label>
                            </div>
                          </li>
                          <li className="d-inline-block mr-2">
                            <div className="custom-control custom-radio custom-control-inline">
                              <input
                                type="radio"
                                name="service"
                                defaultValue={132}
                                id="service_2"
                                onclick="service('2')"
                                className="custom-control-input"
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="service_2"
                              >
                                Balance Enquiry
                              </label>
                            </div>
                          </li>
                          {/**/}
                          <li className="d-inline-block mr-2">
                            <div className="custom-control custom-radio custom-control-inline">
                              <input
                                type="radio"
                                name="service"
                                defaultValue={131}
                                id="service_4"
                                onclick="service('4')"
                                className="custom-control-input"
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="service_4"
                              >
                                Mini Statement
                              </label>
                            </div>
                          </li>
                        </ul>
                        {/*<div class="card-header">
                           <h5 class="card-title">Aeps</h5>
                           </div>*/}
                        <div className="card-content">
                          <div className="card-body">
                            <div className="form-body">
                              <div className="row">
                                <div className="col-md-7 col-sm-12">
                                  {/*<h6 class="text-danger">Minimum Withdrawl Amount Limit  is 501</h6>*/}
                                  <div className="form-group">
                                    <label
                                      htmlFor="email-id-vertical"
                                      className=""
                                    >
                                      Aadhaar Number
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control mt-1 num"
                                      maxLength={12}
                                      id="aadhar_number"
                                      placeholder="Aadhaar Number"
                                    />
                                  </div>
                                  <div className="form-group">
                                    <label
                                      htmlFor="contact-info-vertical"
                                      className="mt-3"
                                    >
                                      Mobile Number
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control mt-1 num"
                                      maxLength={10}
                                      id="mobile_number"
                                      placeholder="Mobile Number"
                                    />
                                  </div>
                                  <div className="form-group" id="amt_box">
                                    <label
                                      htmlFor="contact-info-vertical"
                                      className="mt-3"
                                    >
                                      Amount
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control mt-1"
                                      id="amount"
                                      placeholder="Amount"
                                    />
                                    <button
                                      className="btn btn-primary btn-small mt-2"
                                      onclick="setAm('500')"
                                    >
                                      500
                                    </button>
                                    <button
                                      className="btn btn-primary btn-small mt-2"
                                      onclick="setAm('1000')"
                                    >
                                      1000
                                    </button>
                                    <button
                                      className="btn btn-primary btn-small mt-2"
                                      onclick="setAm('2000')"
                                    >
                                      2000
                                    </button>
                                    <button
                                      className="btn btn-primary btn-small mt-2"
                                      onclick="setAm('5000')"
                                    >
                                      5000
                                    </button>
                                    <button
                                      className="btn btn-primary btn-small mt-2"
                                      onclick="setAm('10000')"
                                    >
                                      10000
                                    </button>
                                  </div>
                                  <div className="form-group mt-3">
                                    <label htmlFor="email-id-vertical">
                                      Bank
                                    </label>
                                  <Select options={bankOptions} />
                                    <span
                                      className="select2 select2-container select2-container--default"
                                      dir="ltr"
                                      data-select2-id="select2-data-1-ht63"
                                      style={{ width: "100%" }}
                                    >
                                      <span
                                        className="dropdown-wrapper"
                                        aria-hidden="true"
                                      />
                                    </span>
                                    <img
                                      className="img-fluid img-responsive height-50 width-100"
                                      onclick="bankSel('607152')"
                                      src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/HDFC_Bank_Logo.svg/2560px-HDFC_Bank_Logo.svg.png"
                                    />
                                    <img
                                      className="img-fluid img-responsive height-50 width-100"
                                      onclick="bankSel('508534')"
                                      src="data:image/png;base64,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"
                                    />
                                    <img
                                      className="img-fluid img-responsive height-50 width-100"
                                      onclick="bankSel('607094')"
                                      src="data:image/png;base64,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"
                                    />
                                  </div>
                                  <ul className="list-unstyled mb-0 mt-3">
                                    <li className="d-inline-block mr-2">
                                      <div className="custom-control custom-radio custom-control-inline">
                                        <input
                                          type="radio"
                                          name="device"
                                          defaultChecked="checked"
                                          defaultValue="MANTRA_PROTOBUF"
                                          id="device_id1"
                                          className="custom-control-input"
                                        />
                                        <label
                                          className="custom-control-label"
                                          htmlFor="device_id1"
                                        >
                                          Mantra
                                        </label>
                                      </div>
                                    </li>
                                    <li className="d-inline-block mr-2">
                                      <div className="custom-control custom-radio custom-control-inline">
                                        <input
                                          type="radio"
                                          name="device"
                                          defaultValue="MORPHO_PROTOBUF"
                                          id="device_id2"
                                          className="custom-control-input"
                                        />
                                        <label
                                          className="custom-control-label"
                                          htmlFor="device_id2"
                                        >
                                          Morpho
                                        </label>
                                      </div>
                                    </li>
                                    <li className="d-inline-block mr-2  mt-2">
                                      <fieldset>
                                        <div className="">
                                          <input
                                            type="checkbox"
                                            name="agree"
                                            id="agree"
                                          />
                                          <span className="">
                                            I hereby voluntarity give consent to
                                            use my AADHAR / VID details to
                                            Authenticate me from UIDAI.
                                          </span>
                                        </div>
                                      </fieldset>
                                    </li>
                                  </ul>
                                  <div className="form-group mt-2">
                                    <button
                                      className="btn btn-primary btn-small"
                                      id="scan_btn"
                                      onclick="scan(12279)"
                                    >
                                      Capture
                                    </button>
                                    <button
                                      className="btn btn-primary btn-small"
                                      id="submit_btn"
                                      disabled=""
                                      onclick="bal()"
                                    >
                                      Submit
                                    </button>
                                  </div>
                                  {/**/}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="position-fixed bottom-0 end-0 m-3 z-index-5">
        {/*<button class="btn btn-square btn-theme shadow" type="button" data-bs-toggle="offcanvas" data-bs-target="#theming" aria-controls="theming"><i class="bi bi-palette"></i></button>*/}
        <br />
        <button
          className="btn btn-theme btn-square rounded-circle shadow mt-2 d-none"
          id="backtotop"
        >
          <i className="bi bi-arrow-up" />
        </button>
      </div>
      <div
        className="offcanvas offcanvas-end shadow border-0"
        tabIndex={-1}
        id="theming"
        data-bs-scroll="true"
        data-bs-backdrop="false"
        aria-labelledby="theminglabel"
      >
        <div className="offcanvas-header border-bottom">
          <div>
            <h5 className="offcanvas-title" id="theminglabel">
              Personalize
            </h5>
            <p className="text-secondary small">Make it more like your own</p>
          </div>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <div className="offcanvas-body">
          <h6 className="offcanvas-title">Colors</h6>
          <p className="text-secondary small mb-4">
            Change colors of templates
          </p>
          <div className="row mb-4 theme-select">
            <div className="col-auto">
              <div className="select-box text-center mb-2" data-title="">
                <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                  <i className="bi bi-arrow-clockwise" />
                </span>
              </div>
            </div>
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="theme-blue"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-blue" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="theme-indigo"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-indigo" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="theme-purple"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-purple" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="theme-pink"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-pink" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="theme-red"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-red" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="theme-orange"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-orange" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="theme-yellow"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-yellow" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="theme-green"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-green" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="theme-teal"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-teal" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="theme-cyan"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-cyan" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="theme-grey"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-grey" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="theme-brown"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-brown" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="theme-chocolate"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-chocolate" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="theme-black"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-dark" />
              </div>
            </div>
          </div>
          <h6 className="offcanvas-title">Backgrounds</h6>
          <p className="text-secondary small mb-4">
            Change color for background
          </p>
          <div className="row mb-4 theme-background">
            <div className="col-auto">
              <div
                className="gradient-box text-center mb-2"
                data-title="bg-default"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                  <i className="bi bi-arrow-clockwise" />
                </span>
              </div>
            </div>
            <div className="col-auto">
              <div
                className="gradient-box text-center mb-2"
                data-title="bg-white"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-white" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="gradient-box text-center mb-2"
                data-title="bg-r-gradient"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-r-gradient" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="gradient-box text-center mb-2"
                data-title="bg-gradient-1"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-1" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="gradient-box text-center mb-2"
                data-title="bg-gradient-2"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-2" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="gradient-box text-center mb-2"
                data-title="bg-gradient-3"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-3" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="gradient-box text-center mb-2"
                data-title="bg-gradient-4"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-4" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="gradient-box text-center mb-2"
                data-title="bg-gradient-5"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-5" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="gradient-box text-center mb-2"
                data-title="bg-gradient-6"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-6" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="gradient-box text-center mb-2"
                data-title="bg-gradient-7"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-7" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="gradient-box text-center mb-2"
                data-title="bg-gradient-8"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-8" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="gradient-box text-center mb-2"
                data-title="bg-gradient-9"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-9" />
              </div>
            </div>
            <div className="col-auto">
              <div
                className="gradient-box text-center mb-2"
                data-title="bg-gradient-10"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-10" />
              </div>
            </div>
          </div>
          <h6 className="offcanvas-title">Sidebar Layout</h6>
          <p className="text-secondary small mb-4">
            Change sidebar layout style
          </p>
          <div className="row mb-4 sidebar-layout">
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="adminuiux-sidebar-standard"
                data-bs-toggle="tooltip"
                aria-label="None"
                data-bs-original-title="None"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                  <i className="bi bi-arrow-clockwise" />
                </span>
              </div>
            </div>
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="adminuiux-sidebar-iconic"
                data-bs-toggle="tooltip"
                aria-label="Iconic"
                data-bs-original-title="Iconic"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                  <i className="bi bi-bezier h4" />
                </span>
              </div>
            </div>
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="adminuiux-sidebar-boxed"
                data-bs-toggle="tooltip"
                aria-label="Boxed"
                data-bs-original-title="Boxed"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                  <i className="bi bi-box h5" />
                </span>
              </div>
            </div>
            <div className="col-auto">
              <div
                className="select-box text-center mb-2"
                data-title="adminuiux-sidebar-boxed adminuiux-sidebar-iconic"
                data-bs-toggle="tooltip"
                aria-label="Iconic+Boxed"
                data-bs-original-title="Iconic+Boxed"
              >
                <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                  <i className="bi bi-bounding-box h5" />
                </span>
              </div>
            </div>
          </div>
          <div className="text-center mb-4">
            <a
              href="investment-personalization.html"
              className="btn btn-sm btn-outline-theme"
            >
              More options <i className="bi bi-arrow-right-short" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
      </div>
    </>
  );
}